import { render } from "./SearchFrameInformation.vue?vue&type=template&id=0d81e89b"
import script from "./SearchFrameInformation.vue?vue&type=script&lang=js"
export * from "./SearchFrameInformation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-protal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__